"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateRules = void 0;
exports.narrowStateStatus = narrowStateStatus;
const _base_1 = require("./_base");
const _FEDERAL_1 = require("./_FEDERAL");
/**
 * A state without generator tiers of its own takes the default `never` and
 * an empty `stateStatusDomain`, so its state status always narrows to missing.
 */
class StateRules extends _base_1.JurisdictionRules {
    /** The federal name for the federal status; a state with names of its own overrides this. */
    describeGeneratorStatus(facility) {
        return _FEDERAL_1.Federal.describeGeneratorStatus(facility);
    }
}
exports.StateRules = StateRules;
/**
 * The facility's state generator status if this state's law defines it, and
 * missing otherwise: a stored status outside the domain is data corruption,
 * read the same as an unknown one.
 */
function narrowStateStatus(facility, domain) {
    return domain.find((status) => status === facility.stateGeneratorStatus);
}
//# sourceMappingURL=_stateRules.js.map